import React, { Component, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import IsOutdoorShadeSelector from '../../ShadeForm/IsOutdoorShadeSelector';
import ShadeForm from './ShadeForm';

import { upperFirst } from 'lodash';

import Button from '../../../Parts/Button';
import SpinningWheel from '../../../Parts/SpinningWheel';
import Money from '../../../Parts/Money';
import { captureSentryError } from '../../../psUtil';
import { EditPSOutdoorShadeModalInner } from '../../EditPSOutdoorShadeModal';
import { useNewPSOutdoorShadeOptions } from '../../../Store/entities/assemblies/PSOutdoorHooks';
import { InitialAssemblyState } from '../../../Store/entities/assemblies';
import { useQuoteTypeNameByQuoteId } from '../../../Store/entities/quotes/hooks';

class NewShadeForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			shade: null,
			shadeErrors: [],
			isOutdoorShade: null,
			doneGettingId: false

		};

		this.selectIndoor = this.selectIndoor.bind(this);
		this.selectOutdoor = this.selectOutdoor.bind(this);
		this.selectShade = this.selectShade.bind(this);
		this.setShadeId = this.setShadeId.bind(this);
		this.done = this.done.bind(this);
		this.attemptAdd = this.attemptAdd.bind(this);
	}

	selectIndoor() {
		this.selectShade(false);
	}

	selectOutdoor() {
		this.selectShade(true);
	}

	setShadeId(data) {
		this.setState({
			shade: this.props.newQuote.Data.shadeSubstitute(data.sequenceId),
			doneGettingId: true
		});
	}

	selectShade(isOutdoor) {
		if (isOutdoor) {
			this.props.openAddPsOutdoorShade();
		}else {
			this.props.newQuote.addAndGetNewShade(isOutdoor, this.setShadeId);
		} 

		this.setState({
			shade: null,
			isOutdoorShade: isOutdoor,
			fetchingPrice: null,
			shadeErrors: [],
			doneGettingId: false
		});
	}

	attemptAdd() {
		let unfinished = false;
		const untouched_arr = [];

		const { shade, isOutdoorShade } = this.state;

		if (!shade || !shade?.options) {
			console.error({ shade });
			console.error({ state: this.state });
			captureSentryError(new Error('Shade or shade.options is null in NewShadeForm.attemptAdd()'));
		}

		shade
			.options()
			.forEach((opt) => {
				if (
					opt.varName != 'price'
					& opt.varName != 'msrp'
					& opt.varName != 'tube_name'
					& opt.varName != 'shade_assembly_id'
					& opt.varName != 'shade_1_id'
					& opt.varName != 'shade_2_id'
					& opt.varName != 'tube_sku'
					& opt.varName != 'coupledShades'
					& (opt.conditional == null || opt.conditional(shade))
				) {
					if ((opt.nullable == undefined || !opt.nullable(shade)) && (opt.value || shade.val(opt.varName)) == null) {
						unfinished = true;
						untouched_arr.push(opt.varName);
					}
				}
			});

		if (unfinished) {
			const missing_field_els = untouched_arr.map((varName) => <li key={varName}>{upperFirst(varName).replace(/_/g, ' ')}</li>);
			const { props } = this;

			ROOT.alert({
				icon: "error",
				title: 'Missing Fields',
				text: <div style={{ zIndex: 999999 }}>
					Please fill out all required fields.
					<br />
					<ul>{missing_field_els}</ul>
				</div>,
				oneButton: true
			})
				.then(() => {
					// ! This isn't expecting a bool and is causing an error.
					// ! sentry issue 3629877343
					// props.setShowRequired(true);
				});

			return;
		}

		this.done(false);
	}

	done(isCanceled = true) {
		if (isCanceled && this.state.shade) {
			this.props.newQuote.Data.deleteAssembly(this.state.shade.sequenceId);
		}
		try {
			this.props.newQuote.UI.reRenderTable();
			this.props.close();
		} catch (e) {
			ROOT.alert({
				quickFormat: 'error',
				message: 'Something went wrong. Please try again.'
			});
			throw new Error(`Error closing new shade form and re-rendering quote table: ${e}`);
		}
	}

	render() {
		const { props } = this;

		const { quote } = props;

		const {
			isOutdoorShade, shade, userMultiplier, fetchingPrice, shadeErrors, doneGettingId
		} = this.state;

		const { quoteType } = props;
		const shadeData = shade?.data();

		const add_button_disabled = fetchingPrice || isOutdoorShade === null || shadeErrors.length;


		return (
			<>
				<h3 className={`text-${this.props.quoteType}`}>
					{isOutdoorShade === null
						? 'New Shade'
						: isOutdoorShade === true
							? 'New Outdoor Shade'
							: 'New Indoor Shade'}
				</h3>
				{isOutdoorShade !== null && doneGettingId ? (
					<h4 className={`text-${quoteType}`}>All Fields Required</h4>
				) : null}

				{isOutdoorShade === null ? (
					<IsOutdoorShadeSelector
						quoteType={quoteType}
						selectOutdoor={this.selectOutdoor}
						selectIndoor={this.selectIndoor}
					/>
				) : !doneGettingId ? (
					<div>
						<span>
							<SpinningWheel
								style={{ fontSize: '2em' }}
								className={`text-${quoteType}`}
							/>
						</span>
					</div>
				) : isOutdoorShade ? (
					idk

				) : (
					<ShadeForm
						quoteType={quoteType}
						newShade
						shade={shade}
						quote={quote}
						quoteData={this.props.newQuote.Data}
					/>
				)}

				{!shadeData ? null : shadeData.msrp && shadeData.msrp !== 0.0 ? (
					<div className={`shade-price text-${quoteType}`}>
						<Money value={shadeData.msrp} />
					</div>
				) : null}

				<Container className="local-bootstrap">
					<Row className="mt-4 mb-2">
						<Col sm={6} xl={4}>
							<Button fullWidth color="grey" onClick={this.done}>
								Cancel
							</Button>
						</Col>
						<Col xl={4} className="d-none d-xxl-block d-xl-block" />
						<Col sm={6} xl={4} className="text-end">
							<Button
								fullWidth
								disabled={add_button_disabled}
								color={quoteType}
								onClick={this.attemptAdd}
							>
								{fetchingPrice ? 'Calculating...' : 'Add Shade'}
							</Button>
						</Col>
					</Row>
				</Container>
			</>
		);
	}
}

export default NewShadeForm;
